module.exports = "/_next/static/images/9aba18fad61a0ff7966ded3573047e97-roxinho-scene-card-with-phone-xs@2x.jpg.webp";